export const FIXED_BODY_CLASS = 'fixed';

export const SHOW_ATTRIBUTE = 'show';
